import { stopMimic } from "../../services/apiClient.js";

// Shown while the System Owner is mimicking another user (debugging tool).
// The whole session IS that user until "Return". Full reload on return so every
// page, permission and theme resets as the restored identity.
function MimicBanner({ currentUser }) {
  if (!currentUser?.mimic) return null;

  async function handleReturn() {
    await stopMimic();
    window.location.assign("/");
  }

  return (
    <div className="alert alert-warning d-flex justify-content-between align-items-center rounded-0 mb-0 py-2">
      <span>
        <strong>Mimicking {currentUser.full_name}</strong> — you are seeing ClaimsDesk
        exactly as they do.
      </span>
      <button type="button" className="btn btn-sm btn-outline-dark" onClick={handleReturn}>
        Return to {currentUser.mimic.real_full_name}
      </button>
    </div>
  );
}

export default MimicBanner;
